var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dictation"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4329 44.5896L24.0803 31.7436H42.5851L20.1239 44.9218L20.1073 44.9317C19.9595 45.0208 19.7735 45.0165 19.6298 44.9208C19.5159 44.8449 19.4449 44.7223 19.4329 44.5896Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0803 28.4314H42.5851L20.1073 15.2434C19.9594 15.1543 19.7734 15.1584 19.6298 15.2542C19.5159 15.3301 19.4448 15.4527 19.4329 15.5853L24.0803 28.4314Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9198 59.8935C46.3831 59.8935 59.7292 46.5474 59.7292 30.0841C59.7292 13.6208 46.3831 0.274658 29.9198 0.274658C13.4565 0.274658 0.110352 13.6208 0.110352 30.0841C0.110352 46.5474 13.4565 59.8935 29.9198 59.8935ZM49.4899 28.6424L21.8071 12.4006C20.5627 11.6558 19.0003 11.6934 17.793 12.498C16.5825 13.3047 15.9463 14.7374 16.1595 16.1763C16.1757 16.2856 16.2028 16.393 16.2404 16.4969L21.1572 30.0875L16.2405 43.678C16.2029 43.782 16.1758 43.8894 16.1596 43.9987C15.9463 45.4376 16.5826 46.8703 17.793 47.677C19.0004 48.4816 20.5628 48.5192 21.8072 47.7743L49.4886 31.5334C49.5096 31.5216 49.5303 31.5093 49.5508 31.4967C49.6531 31.4336 49.7493 31.3589 49.8371 31.2732C49.9358 31.177 50.0208 31.07 50.0912 30.9552C50.1916 30.7925 50.2645 30.611 50.3037 30.4173C50.3252 30.3112 50.3361 30.2041 50.3366 30.0975C50.3375 29.9759 50.3249 29.8535 50.2984 29.7326C50.2583 29.5489 50.1877 29.3766 50.0922 29.2213C50.0251 29.1116 49.9446 29.009 49.8516 28.9162C49.7528 28.8171 49.6429 28.7324 49.5252 28.6627C49.5135 28.6558 49.5018 28.649 49.4899 28.6424Z",
    fill: "#B0B0B0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessageIcon);
export default __webpack_public_path__ + "static/media/sendMessageIcon.f8c6bbd5fd0f402fbbce563d7dd2d919.svg";
export { ForwardRef as ReactComponent };